const config = {
    host: (process.env.NODE_ENV === 'production') ? 'https://panago.dvgeo.app' : 'http://192.168.100.106:3019',
    homePage: (process.env.NODE_ENV === 'production') ? 'https://panago.dvgeo.app' : 'http://192.168.100.106:3019',
    api: 'api/',
    apiSocket: 'panago::1.2',
    nameDir: 'panago',
    package: 'app.dvgeo.panago.web',
    version: '1.0.0',
    googleAPIKey: 'AIzaSyDWQtN4E9qs_H-VLSip7HS48UmlN2pjf-Q',
    appName: 'PANAGO',
    provider: 'Devjos CIA LTDA',
    colorPrimary: '#d77627',
    colorDark: '#2892b9',
    colorAccent: '#ccc',
    colorTextPrimary: '#fff',
    colorTextDark: '#000',
    playStorePassengerId: 'app.dvgeo.panago.passenger',
    playStoreDriverId: 'app.dvgeo.panago.driver',
    appStorePassengerId: '6760432878',
    appStoreDriverId: '6760433094',
};
export default config;
